import { createClient } from "@sanity/client";
import {createImageUrlBuilder} from "@sanity/image-url";

export const client = createClient({
  projectId: process.env.REACT_APP_SANITY_PROJECT_ID,
  dataset: process.env.REACT_APP_SANITY_DATASET || "production",
  apiVersion: process.env.REACT_APP_SANITY_API_VERSION || "2024-01-01",
  useCdn: process.env.NODE_ENV === "production",
});

const builder = createImageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);
